import { render } from "./Redirect.vue?vue&type=template&id=4622dc6b&scoped=true&ts=true"
import script from "./Redirect.vue?vue&type=script&lang=ts"
export * from "./Redirect.vue?vue&type=script&lang=ts"

import "./Redirect.vue?vue&type=style&index=0&id=4622dc6b&lang=less&scoped=true"

import exportComponent from "/Users/yzh-mac/Documents/inm/git/砺成文化/word-admin-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4622dc6b"]])

export default __exports__